var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimulationStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Stop simulation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-stop",
    "data-name": "Icon awesome-stop",
    d: "M71.429,2.25H8.571A8.574,8.574,0,0,0,0,10.821V73.679A8.574,8.574,0,0,0,8.571,82.25H71.429A8.574,8.574,0,0,0,80,73.679V10.821A8.574,8.574,0,0,0,71.429,2.25Z",
    transform: "translate(0 -2.25)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimulationStop);
export default __webpack_public_path__ + "static/media/simulationStop.e55a6eb164c1ca97f38e13eabca3ccbb.svg";
export { ForwardRef as ReactComponent };